module.exports = __webpack_public_path__ + "img/sattelite-white.0fadbd2c.svg";